import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import BaseDetailScreen from '../BaseDetailScreen';
import BaseModal from '../BaseModal';
import Button from '../Button';
import { cancelIndicationById } from '../../actions/indicateInterest';
import './index.css';
import CloseIcon from '../../assets/images/close_gray.svg';
import blueCheck from '../../assets/images/blue_confirmation_check.png';

class RemoveOfferWatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuccessDialog: false,
    };
  }

  async cancelIndicationById(offerWatchId) {
    await this.props.cancelIndicationById(offerWatchId);
    this.setState({ showSuccessDialog: true });
  }
  render() {
    const { offerWatchId } = this.props.match.params;
    const content = this.state.showSuccessDialog ? (
      <BaseModal onClose={() => this.props.history.push('/offers')}>
        <div styleName="dialogHeader">
          <button onClick={() => this.setState({ showSuccessDialog: !this.state.showSuccessDialog })} type="button" styleName="dialogHeaderCloseBtn">
            <img width="12" src={CloseIcon} alt="icon" />
          </button>
        </div>
        <div styleName="dialogTitle">
          <img src={blueCheck} alt="Warning" style={{ width: 120, height: 120 }} />
          <p>Success</p>
        </div>
        <div styleName="dialogText">
          You have been unsubscribed successfully.
        </div>
        <div styleName="dialogActions">
          <Button
            stylename="btnSecondaryAlt"
            onClick={() => this.props.history.push('/offers')}
          >
            Close
          </Button>
        </div>
      </BaseModal>
    ) : (
      <BaseDetailScreen
        pageHeading="Cancel Indication"
        backTo="/offers"
        backLabel="Offers"
      >
        <span styleName="messageSpan">Are you sure you want to cancel your indication of interest?</span>
        <div styleName="textContainer">
          <Button onClick={() => this.cancelIndicationById(offerWatchId)}>Cancel</Button>
          <Link to="/offers">Do not cancel</Link>
        </div>
      </BaseDetailScreen>);
    return content;
  }
}

const mapDispatchToProps = {
  cancelIndicationById,
};

export default connect(() => {}, mapDispatchToProps)(withRouter(RemoveOfferWatch));



// WEBPACK FOOTER //
// ./src/components/OfferWatches/RemoveOfferWatch.js